/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { Auth0AccountRole } from "./Auth0AccountRole";
import type { PublicFieldView } from "./PublicFieldView";
import type { PublicPaymentStep } from "./PublicPaymentStep";
import type { PublicPayrollStep } from "./PublicPayrollStep";
import type { PublicStudentBlock } from "./PublicStudentBlock";

/**
 * Everything the page needs. state: open, done (already filled out) or invalid.
 */
export type PublicFormView = {
  state: PublicFormView.state;
  org_name?: string | null;
  form_name?: string | null;
  intro?: string | null;
  revision?: number | null;
  recipient_type?: Auth0AccountRole | null;
  recipient_first_name?: string | null;
  parent_fields?: Array<PublicFieldView> | null;
  student_blocks?: Array<PublicStudentBlock> | null;
  allow_add_students?: boolean;
  new_student_fields?: Array<PublicFieldView> | null;
  tutor_fields?: Array<PublicFieldView> | null;
  terms_text?: string | null;
  payment?: PublicPaymentStep | null;
  payroll_bank?: PublicPayrollStep | null;
};

export namespace PublicFormView {
  export enum state {
    OPEN = "open",
    DONE = "done",
    INVALID = "invalid",
  }
}
